<script lang="ts">
export default {
  name: 'ClBadge'
};
</script>
<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed } from 'vue';

import type { BadgeVariantType } from '#components/badge/badge.model';

const props = defineProps({
  value: { type: [Number, String], default: null },
  title: { type: [Number, String], default: null },
  tag: { type: String, default: 'div' },
  disabled: { type: Boolean, default: false },
  variant: { type: String as PropType<BadgeVariantType>, default: 'default' }
});

const clx = computed(() => ({
  'text-black bg-background-main ': props.variant === 'default',
  'text-white bg-primary': props.variant === 'strong',
  'text-white bg-error': props.variant === 'notification',
  'opacity-75': props.disabled,
  'h-3 !bg-error': !props.value
}));
</script>

<template>
  <component
    :is="tag"
    :title="title"
    class="inline-block rounded-full !px-1.5 font-bold text-sm leading-5"
    :class="clx"
  >
    {{ value }}
  </component>
</template>
